import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import API from 'services/API';
import config from 'config';
import find from 'lodash/find';
import get from 'lodash/get';
import features from 'lib/common/features';
import arrayWrap from 'lib/common/arrayWrap';
import { redirectWithError } from 'lib/common/fallbacks';

import SYOSContainer from 'containers/SYOSContainer';
import LevelSelectorContainer from 'containers/LevelSelectorContainer';

const AppContainer = createReactClass({
  displayName: 'AppContainer',
  propTypes: {
    endpoint: PropTypes.string.isRequired,
    onComplete: PropTypes.func.isRequired,
    initialSessionKey: PropTypes.string,
    initialPerformanceId: PropTypes.number.isRequired,
    initialMos: PropTypes.number,
    initialPromoCode: PropTypes.number,
    packageNo: PropTypes.number,
    facilityNo: PropTypes.number,
    queryParams: PropTypes.object,
    initialSelectedLevel: PropTypes.string
  },
  getInitialState: function() {
    /**
         * If we are provided the MOS and promo/source code
         * ahead of time we can pre-populate loginInfo
         */
    var loginInfo = null;
    if (this.props.initialMos && this.props.initialPromoCode) {
      loginInfo = {
        MOS: this.props.initialMos,
        promotion_code: this.props.initialPromoCode
      };
    }

    var currentFacility = find(config.facilityMapping, item => {
      return item.facility_no === this.props.facilityNo;
    });

    return {
      performanceId: this.props.initialPerformanceId,
      hasSession: false,
      loginInfo: loginInfo,
      maxTickets: null,
      currentFacility: currentFacility,
      usesGeneratedSeatmap: !currentFacility,
      detailsWithDiscounting: null,
      seatData: [],
      screenData: [],
      screenZoneData: null,
      details: null,
      prices: [],
      activePromoCode: null,
      selectedLevel: null,
      initialSelectedLevel: this.props.initialSelectedLevel
        ? {
            selector: this.props.initialSelectedLevel,
            newZoom: 1
          }
        : null
    };
  },
  getLoginInfo: function() {
    if (this.state.loginInfo) {
      return Promise.resolve(this.state.loginInfo);
    } else {
      return API.loginInfo();
    }
  },
  componentWillMount: function() {
    API.configure(this.props.endpoint, this.props.initialSessionKey);
  },
  componentDidMount: function() {
    /* global __DEV__ */
    if (__DEV__) {
      features.logEnabledFeatures();
    }

    API.getSessionKey()
      .then(() => {
        this.setState({
          hasSession: true
        });

        Promise.all([
          this.getLoginInfo(),
          API.getMaxTicketAmount()
        ]).then(results => {
          let [loginInfo, maxTickets] = results;

          this.setState({
            loginInfo: loginInfo,
            maxTickets: maxTickets
          });

          this.fetchCoreData(this.state.performanceId, loginInfo);
        }, redirectWithError);
      })
      .catch(redirectWithError);
  },
  fetchCoreData(performanceId, loginInfo, refreshSeatData) {
    API.getDetailsWithDiscounting(
      performanceId,
      this.props.packageNo,
      loginInfo
    ).then(result => {
      var details = {
        summary:
          this.props.packageNo && result.Package
            ? result.Package
            : result.Performance,
        webContent: arrayWrap(result.WebContent)
      };

      var enabledPrices = arrayWrap(result.PriceType).map(_ => _.price_type);
      var prices = arrayWrap(result.AllPrice).filter(function(price) {
        return enabledPrices.indexOf(price.price_type) !== -1;
      });

      const singleSeatswebContentDescription = features.getOption(
        'orphanSeats',
        'leaveSingleSeatsWebContentDescription'
      );

      const singleSeatsWebContent =
        singleSeatswebContentDescription &&
        find(
          details.webContent,
          field => field.content_type_desc === singleSeatswebContentDescription
        );

      var leaveSingleSeats = get(singleSeatsWebContent, 'content_value', 'N');
      leaveSingleSeats = leaveSingleSeats === 'Yes' ? 'Y' : 'N';

      this.setState({
        detailsWithDiscounting: result,
        details: details,
        prices: prices,
        leaveSingleSeats: leaveSingleSeats
      });
    });

    // If we're refreshing the seat map then run this call twice
    if (refreshSeatData) {
      API.getSeatmapData(
        performanceId,
        this.props.packageNo,
        loginInfo.MOS,
        loginInfo.promotion_code,
        this.state.usesGeneratedSeatmap,
        refreshSeatData
      ).then(() => {
        let seatDataTimeout = setTimeout(() => {
          API.getSeatmapData(
            performanceId,
            this.props.packageNo,
            loginInfo.MOS,
            loginInfo.promotion_code,
            this.state.usesGeneratedSeatmap,
            refreshSeatData
          ).then(result => {
            this.setState({
              seatData: get(result, 'seatsResults'),
              screenData: get(result, 'screensResults.Screens'),
              screenZoneData: get(result, 'screenZoneData')
            });
          });
          clearTimeout(seatDataTimeout);
        }, 5000);
      });
    } else {
      API.getSeatmapData(
        performanceId,
        this.props.packageNo,
        loginInfo.MOS,
        loginInfo.promotion_code,
        this.state.usesGeneratedSeatmap,
        refreshSeatData
      ).then(result => {
        this.setState({
          seatData: get(result, 'seatsResults'),
          screenData: get(result, 'screensResults.Screens'),
          screenZoneData: get(result, 'screenZoneData')
        });
      });
    }
  },
  onLevelSelected: function(selector, newZoom) {
    this.setState({
      selectedLevel: {
        selector: selector,
        newZoom: newZoom
      }
    });
  },
  onChangePerformance: function(performanceId, refreshSeatData) {
    this.setState({
      performanceId: performanceId,
      details: null,
      prices: [],
      seatData: [],
      screenData: []
    });

    this.fetchCoreData(performanceId, this.state.loginInfo, refreshSeatData);
  },
  onPromoCodeReady: function(activePromoCode) {
    if (activePromoCode) {
      this.setState({
        activePromoCode: activePromoCode
      });
    }
  },
  render: function() {
    var levelSelectorConfig = get(this.state.currentFacility, 'levelSelector');
    var isOldIE =
      (!!window.MSInputMethodContext && !!document.documentMode) ||
      window.navigator.userAgent.indexOf('MSIE ') != -1 ||
      window.navigator.userAgent.indexOf('Trident/') != -1;

    var shouldRenderLevelSelector =
      this.state.hasSession &&
      features.isEnabled('levelSelector') &&
      levelSelectorConfig &&
      !this.state.selectedLevel &&
      !this.props.queryParams.skip_level_selector &&
      !isOldIE;

    let selectedLevel = this.state.selectedLevel;
    if (this.state.initialSelectedLevel) {
      selectedLevel = this.state.initialSelectedLevel;
      this.setState({
        selectedLevel: selectedLevel,
        initialSelectedLevel: null
      });
    }

    if (shouldRenderLevelSelector) {
      return (
        <LevelSelectorContainer
          loginInfo={this.state.loginInfo}
          details={this.state.details}
          performanceId={this.state.performanceId}
          levelSelectorConfig={levelSelectorConfig}
          onPromoCodeReady={this.onPromoCodeReady}
          onLevelSelected={this.onLevelSelected}
        />
      );
    } else {
      return this.state.loginInfo ? (
        <SYOSContainer
          performanceId={this.state.performanceId}
          packageNo={this.props.packageNo}
          maxTickets={this.state.maxTickets}
          loginInfo={this.state.loginInfo}
          details={this.state.details}
          prices={this.state.prices}
          seatData={this.state.seatData}
          screenData={this.state.screenData}
          screenZoneData={this.state.screenZoneData}
          selectedLevel={selectedLevel}
          currentFacility={this.state.currentFacility}
          usesGeneratedSeatmap={this.state.usesGeneratedSeatmap}
          activePromoCode={this.state.activePromoCode}
          onChangePerformance={this.onChangePerformance}
          onPromoCodeReady={this.onPromoCodeReady}
          onComplete={this.props.onComplete}
          leaveSingleSeats={this.state.leaveSingleSeats}
        />
      ) : null;
    }
  }
});

export default AppContainer;



// WEBPACK FOOTER //
// ./src/javascripts/app/containers/AppContainer.js